// Imported first by index.tsx, so fetch and WebSocket are relayed before any
// other module runs (see client.ts).
import { installDevBackendRelay } from './client';

installDevBackendRelay();
